import styles from './styles.module.css';

interface TagProps {
  text: string;
}

export const Tag = ({ text }: TagProps) => (
  <div className={styles.badge}>
    <span className={styles.text}>{text}</span>
  </div>
);
